import { render, staticRenderFns } from "./DirectLayout.vue?vue&type=template&id=620db815&scoped=true&"
import script from "./DirectLayout.vue?vue&type=script&lang=js&"
export * from "./DirectLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620db815",
  null
  
)

export default component.exports